export default __webpack_public_path__ + "static/media/000_intro_part2.first.0d763492.webp";